'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'
import { useFormikContext } from 'formik'

// lib
import { accessibilityLabel } from '../_support'
import Button, { ButtonProps } from '../button'
import Loading, { LoadingProps } from '../loading'

/* -----------------------------------------------------------------------------
 * SubmitButton
 * -------------------------------------------------------------------------- */

export type Variants = {
  [key in
    | 'violet'
    | 'violetGradient'
    | 'punchThroughViolet'
    | 'secondary'
    | 'tertiary']: {
    loading: LoadingProps
  }
}

const variants: Variants = {
  violet: { loading: { fill: 'white' } },
  violetGradient: { loading: { fill: 'white' } },
  punchThroughViolet: { loading: { fill: 'violet' } },
  secondary: { loading: { fill: 'white' } },
  tertiary: { loading: { fill: 'walrusBlue500' } }
}

export type SubmitButtonProps = ButtonProps & {}

const SubmitButton = ({
  children,
  variant = 'violetGradient',
  ...rest
}: SubmitButtonProps) => {
  const { handleSubmit, isSubmitting } = useFormikContext()
  const loadingProps = variants[variant]['loading']

  let overlay
  if (isSubmitting) {
    overlay = (
      <Loading
        position='absolute'
        top='50%'
        left='50%'
        size='small'
        {...loadingProps}
      />
    )
  }

  return (
    <Button
      {...accessibilityLabel('Submit')}
      disabled={isSubmitting}
      onPress={handleSubmit as any}
      overlay={overlay}
      variant={variant}
      {...rest}
    >
      {children}
    </Button>
  )
}

export default SubmitButton
